import React from "react";
import PropTypes from "prop-types";
import cs from "classnames";
import classes from "./ToichenStep.module.scss";
import RadioDots from "../../../../atoms/RadioDots";
import QuestionTextArea from "../QuestionTextArea/QuestionTextArea";

const ToichenStep = ({ toichenPossuk, toichenLesson }) => {
  return (
    <div className={cs(classes.toichenStep)}>
      <h2 className={cs(classes.heading, classes.grandstanderFamily)}>
        Toichen
      </h2>
      
      <div className={cs(classes.possukSection)}>
        <label className={cs(classes.label, classes.grandstanderFamily)}>
          My Possuk is:
        </label>
        <RadioDots
          horizontal
          items={toichenPossuk.options}
          value={toichenPossuk.value}
          onChange={toichenPossuk.onChange}
          error={toichenPossuk.error}
          additionalClass="yellowRadio"
          // color="yellowRadio"
        />
      </div>

      <div className={cs(classes.lessonSection)}>
        <QuestionTextArea
          id="toichen-lesson"
          label={
            <>
              In your own words, <strong>what lesson</strong> do you take from this possuk?
            </>
          }
          value={toichenLesson.value}
          onChange={toichenLesson.onChange}
          placeholder="Long Answer text"
          error={toichenLesson.error}
          required={true}
          rows={3}
        />
      </div>
    </div>
  );
};

ToichenStep.propTypes = {
  toichenPossuk: PropTypes.shape({
    options: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
        value: PropTypes.string.isRequired,
      })
    ).isRequired,
    value: PropTypes.string.isRequired,
    error: PropTypes.string,
    onChange: PropTypes.func.isRequired,
  }).isRequired,
  toichenLesson: PropTypes.shape({
    value: PropTypes.string.isRequired,
    error: PropTypes.string,
    onChange: PropTypes.func.isRequired,
  }).isRequired,
};

export default ToichenStep;

